import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { fonts } from "@theme";
import type { TrackRef } from "./types";

export const InboxTrackRow = ({
  track,
  onPress,
  sentryEventName = "inbox_recommendation_press",
}: {
  track: TrackRef;
  onPress?: () => void;
  sentryEventName?: string;
}) => (
  <LPressable
    accessibilityHint="Starts this song"
    accessibilityLabel={`Play ${track.title} by ${track.artistName}`}
    accessibilityRole="button"
    disabled={!onPress}
    fadeEnabled
    onPress={onPress}
    sentryEventName={sentryEventName}
  >
    <LBox alignItems="center" flexDirection="row" gap="s3" py="s1">
      <LArtwork borderRadius="m" size={48} url={track.albumArt} />
      <LBox flex={1} gap="s0_5">
        <LText
          color="white"
          fontFamily={fonts.semiBold}
          fontSize={14}
          lineHeight={18}
          numberOfLines={1}
        >
          {track.title}
        </LText>
        <LText
          color="subGrey"
          fontFamily={fonts.regular}
          fontSize={13}
          lineHeight={17}
          numberOfLines={1}
        >
          {track.artistName}
        </LText>
      </LBox>
      <LBox
        alignItems="center"
        backgroundColor="whiteTranslucent10"
        borderRadius="max"
        height={36}
        justifyContent="center"
        opacity={onPress ? 1 : 0.4}
        width={36}
      >
        <LIcon name="play" size={14} />
      </LBox>
    </LBox>
  </LPressable>
);
